/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs */

const en_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast Forward through video (foot fedal recommended)`)
};

const fr_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance rapide dans la video (pedale recommandee)`)
};

const de_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellvorlauf im Video (Fußfesselung empfohlen)`)
};

const it_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzamento rapido nel video (si consiglia l'uso del piede)`)
};

const ru_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемотайте видео вперед (рекомендуется использовать педаль).`)
};

const es_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance rápido a través del video (se recomienda el uso del pie)`)
};

const zh_cn2_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频快进（建议使用脚踏快进）`)
};

const ja_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオを早送りする（徒歩での視聴を推奨）`)
};

const hi_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो को तेजी से आगे बढ़ाएं (फुट पैडल का इस्तेमाल करने की सलाह दी जाती है)`)
};

const pt_pt2_shortcut_keys_desc_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance rapidamente o vídeo (recomenda-se o uso do pé para avançar).`)
};

/**
* | output |
* | --- |
* | "Fast Forward through video (foot fedal recommended)" |
*
* @param {Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_fast_forward = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_toggle_fast_forward(inputs)
	if (locale === "de") return de_shortcut_keys_desc_toggle_fast_forward(inputs)
	if (locale === "it") return it_shortcut_keys_desc_toggle_fast_forward(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_toggle_fast_forward(inputs)
	if (locale === "es") return es_shortcut_keys_desc_toggle_fast_forward(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_toggle_fast_forward(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_toggle_fast_forward(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_toggle_fast_forward(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_toggle_fast_forward(inputs)
	return en_shortcut_keys_desc_toggle_fast_forward(inputs)
});